import React, {useState, useEffect, useRef} from 'react'
import {useParams, useNavigate} from 'react-router-dom'
import { Row, Col, Card, CardBody, FormGroup, Input, Label, Button, Spinner} from 'reactstrap'
import Select from 'react-select'
import {reactSelectStyles} from '../variables/react-select-styles'
import api from '../api'
import {useDispatch, useSelector} from 'react-redux'
import {setExchanges} from '../redux/actions/exchagesActions'
import {logOut} from '../helpers/hooks'
import {setKeysSets} from '../redux/actions/keysSetsActions'
import {isWatchdog} from '../helpers/roles'
import {setStrategiesTypes} from '../redux/actions/strategyActions'
import Toggle from 'react-toggle'
import 'react-toggle/style.css'
import {setError, setSuccess} from '../redux/actions/alertActions'
import {reactSelectLightStyles} from "../variables/react-select-light-styles";
import { useTranslation } from 'react-i18next'

const StrategyForm = () => {
  const navigate = useNavigate()
  if (isWatchdog()) {
    navigate('/access-denied')
  }
  const {id} = useParams()
  const dispatch = useDispatch()
  const exchangesData = useSelector(state => state.exchanges)
  const keysSetsData = useSelector(state => state.keysSets)
  const strategiesData = useSelector(state => state.strategy)
  const strategyId = Number(id)
  const [tradingPairs, setTradingPairs] = useState([])
  const [balance, setBalance] = useState([])
  const [balanceSlave, setBalanceSlave] = useState([])
  const [balanceLoading, setBalanceLoading] = useState(false)
  const [showTradingPair, setShowTradingPair] = useState(false)
  const [selectedExchange, setSelectedExchange] = useState(null)
  const [update_type, setUpdate_type] = useState({})
  const [formErrors, setFormErrors] = useState({}) // Состояние для ошибок валидации

  // Асинхронное сохранение + reload (контракт BFF):
  //   POST /strategies/update -> { success: true, reload: 'applying' }
  //   затем поллинг GET /strategies/reload_status?id=<sid> каждые 2с.
  // phase: 'idle' | 'applying' | 'failed'
  const [applyState, setApplyState] = useState({phase: 'idle', message: ''})
  const pollRef = useRef(null)          // id setInterval поллинга статуса
  const pollDeadlineRef = useRef(0)     // дедлайн поллинга (Date.now() + POLL_MAX_MS)
  const submitStartedRef = useRef(0)    // время старта текущего сохранения (для проверки свежести 'done'/'failed')
  const seenApplyingRef = useRef(false) // видели ли мы статус 'applying' в текущем цикле поллинга
  const applyingRef = useRef(false)     // синхронная защита от повторной отправки «на лету»
  const isMountedRef = useRef(true)     // защита от setState после размонтирования

  const {t} = useTranslation()

  const [formData, setFormData] = useState({
    enable_all: true,
    name: '',
    type: '',
    exchange: null,
    tradingPair: null,
    keys: null,
    baseBalance: '',
    quoteBalance: '',
    baseBalanceSlave: '',
    quoteBalanceSlave: '',
  })
  const user = JSON.parse(localStorage.getItem('user'))
  const cid = user?.cid
  const uid = user?.uid
  const [onceApi, setOnceApi] = useState(false)
  const [onceApiSlave, setOnceApiSlave] = useState(false)

  useEffect(() => {
    if (strategyId && _.size(strategiesData.types) && _.size(keysSetsData)) {
      api
        .getStrategiesInfo(strategyId)
        .then(res => {
          if (res.strategy_name) {
            const findStrategyType = _.find(
              strategiesData.types,
              type => type.strategy_type_id === res.strategy_type,
            )
            setFormData({
              name: res.strategy_name,
              enable_all: false,
              active: res.active,
              type: {
                value: findStrategyType?.strategy_type_id,
                label: findStrategyType?.strategy_type_name,
                keys: findStrategyType?.key_numbers,
                config: findStrategyType?.config,
              },
              exchange: {value: res.exchange, label: res.exchange},
              tradingPair: {
                value: `${res.pair.base}-${res.pair.quote}`,
                label: `${res.pair.base}-${res.pair.quote}`,
              },
              keys:
                _.map(res.key_sets, key => {
                  const findKey = _.find(keysSetsData.keysSets, keyData => keyData.id === key);
                  if(findKey){
                    return {
                      value: findKey.id,
                      label: findKey.name
                    }
                  }
                }),
              baseBalance: res.balances?.base,
              quoteBalance: res.balances?.quote,
              baseBalanceSlave: res.balances_slave?.base,
              quoteBalanceSlave: res.balances_slave?.quote,
              ...res.config,
            })
            setSelectedExchange({value: res.exchange, label: res.exchange})
            setShowTradingPair(true)
          }
        })
        .catch(e => console.error('getStrategiesInfo error', e))
    }
  }, [strategyId, strategiesData, keysSetsData])

  useEffect(() => {
    if (cid) {
      api
        .getExchanges()
        .then(res => {
          if (res.exchanges) {
            dispatch(setExchanges(res.exchanges))
          }
        })
        .catch(e => console.error('getExchanges error ', e))
      api
        .getCompanyKeys(cid)
        .then(res => {
          if (res.KeysSets) {
            dispatch(setKeysSets(res.KeysSets))
          }
        })
        .catch(e => console.error('getCompanyKeys error ', e))
      api
        .getStrategiesTypes(cid)
        .then(res => {
          if (res.strategies_types) {
            dispatch(setStrategiesTypes(res.strategies_types))
          }
        })
        .catch(e => console.error('getCompanyKeys error ', e))
    } else {
      logOut()
    }
  }, [])

  useEffect(() => {
    if (_.first(formData.keys)?.value && !onceApi) {
      setOnceApi(true)
      setBalanceLoading(true)
      api.getBalance(_.first(formData.keys)?.value)
        .then(res => {
          if (res) {
            setBalance(res)
          }
        })
        .catch((e) => {
          console.error('getBalance error', e)
        })
        .finally(() => {
          setBalanceLoading(false)

        })
    }
    if (formData.keys?.[1]?.value && !onceApiSlave) {
      setOnceApiSlave(true)
      setBalanceLoading(true)
      api.getBalance(formData.keys?.[1]?.value)
        .then(res => {
          if (res) {
            setBalanceSlave(res)
          }
        })
        .catch((e) => {
          console.error('getBalanceSlave error', e)
        })
        .finally(() => {
          setBalanceLoading(false)

        })
    }
  }, [formData.keys]);

  // Останавливаем поллинг reload-статуса при уходе со страницы во время «Применяется…».
  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
      if (pollRef.current) {
        clearInterval(pollRef.current)
        pollRef.current = null
      }
    }
  }, [])

  const handleChange = (name, value) => {
    setFormData({...formData, [name]: value})
    setFormErrors({...formErrors, [name]: false})

    if (name === 'AutoRebalance') {
      setFormErrors({
        ...formErrors,
        StartRebalanceProc: false,
        StartSkipDealsProc: false,
        StopStrategyProc: false,
      })
    }
  }

  const handleStrategyTypeChange = selectedOption => {
    handleChange('type', selectedOption)
  }

  const handleExchangeChange = async (selectedOption) => {
    setSelectedExchange(selectedOption)
    setTradingPairs([])
    setOnceApi(false)
    setOnceApiSlave(false)
    setFormData({
      ...formData,
      tradingPair: null,
      keys: null,
      exchange: selectedOption,
    })

    try {
      const res = await api.getPairs(selectedOption.label)
      if (res.pairs) {
        setTradingPairs(res.pairs)
        setShowTradingPair(true)
      } else {
        setShowTradingPair(false)
      }
    } catch (e) {
      console.error('getPairs error', e)
    }
  }

  const handleKeysChange = (selectedOption, index) => {
    if (formData.keys === null) {
      setFormData({...formData, keys: [selectedOption]})
    } else {
      const updatedKeys = [...formData.keys]
      updatedKeys[index] = selectedOption
      setFormData({...formData, keys: updatedKeys})
    }
    setFormErrors({...formErrors, keys: false})
  }

  const handleTradingPairChange = selectedOption => {
    setFormData({
      ...formData,
      tradingPair: selectedOption,
      baseBalance: balance?.[selectedOption?.value?.split('-')?.[0]] || '',
      quoteBalance: balance?.[selectedOption?.value?.split('-')?.[1]] || '',
    })
  }

  // Функция для валидации формы
  const validateForm = () => {
    const errors = {}

    // symbols and available balances (safe extraction)
    const baseSymbol = formData?.tradingPair?.value?.split('-')?.[0]
    const quoteSymbol = formData?.tradingPair?.value?.split('-')?.[1]
    const baseAvailable = baseSymbol ? balance?.[baseSymbol] : undefined
    const quoteAvailable = quoteSymbol ? balance?.[quoteSymbol] : undefined
    const baseSlaveAvailable = baseSymbol ? balanceSlave?.[baseSymbol] : undefined
    const quoteSlaveAvailable = quoteSymbol ? balanceSlave?.[quoteSymbol] : undefined

    if (!formData.name) {
      errors.name = t('strategyForm.validation.strategyNameRequired')
    }

    if (!formData.type) {
      errors.type = t('strategyForm.validation.strategyTypeRequired')
    }

    if (!formData.exchange) {
      errors.exchange = t('strategyForm.validation.exchangeRequired')
    }

    if (showTradingPair && !formData.tradingPair) {
      errors.tradingPair = t('strategyForm.validation.tradingPairRequired')
    }

    if (formData.type?.keys === 2 && (!formData.keys || formData.keys.length < 2)) {
      errors.keys = t('strategyForm.validation.bothKeysRequired')
    } else if (!formData.keys || formData.keys.length < 1) {
      errors.keys = t('strategyForm.validation.keysRequired')
    }

    if (isNaN(parseFloat(formData.baseBalance))) {
      errors.baseBalance = t('strategyForm.validation.balanceNumber')
    }
    if (!formData.baseBalance) {
      errors.baseBalance = t('strategyForm.validation.balanceRequired')
    }
    if (formData.baseBalance && baseAvailable !== undefined && parseFloat(formData.baseBalance) > parseFloat(baseAvailable)) {
      errors.baseBalance = t('strategyForm.validation.balanceGreater', {value: baseAvailable})
    }
    if (formData.baseBalance && parseFloat(formData.baseBalance) < 0) {
      errors.baseBalance = t('strategyForm.validation.balancePositive')
    }

    if (isNaN(parseFloat(formData.quoteBalance))) {
      errors.quoteBalance = t('strategyForm.validation.balanceNumber')
    }
    if (!formData.quoteBalance) {
      errors.quoteBalance = t('strategyForm.validation.balanceRequired')
    }
    if (formData.quoteBalance && quoteAvailable !== undefined && parseFloat(formData.quoteBalance) > parseFloat(quoteAvailable)) {
      errors.quoteBalance = t('strategyForm.validation.balanceGreater', {value: quoteAvailable})
    }
    if (formData.quoteBalance && parseFloat(formData.quoteBalance) < 0) {
      errors.quoteBalance = t('strategyForm.validation.balancePositive')
    }

    if(formData.type?.value === 1) {
      if (isNaN(parseFloat(formData.baseBalanceSlave))) {
        errors.baseBalanceSlave = t('strategyForm.validation.balanceSlaveNumber')
      }
      if (!formData.baseBalanceSlave) {
        errors.baseBalanceSlave = t('strategyForm.validation.balanceSlaveRequired')
      }
      if (formData.baseBalanceSlave && baseSlaveAvailable !== undefined && parseFloat(formData.baseBalanceSlave) > parseFloat(baseSlaveAvailable)) {
        errors.baseBalanceSlave = t('strategyForm.validation.balanceSlaveGreater', {value: baseSlaveAvailable})
      }
      if (formData.baseBalanceSlave && parseFloat(formData.baseBalanceSlave) < 0) {
        errors.baseBalanceSlave = t('strategyForm.validation.balanceSlavePositive')
      }

      if (isNaN(parseFloat(formData.quoteBalanceSlave))) {
        errors.quoteBalanceSlave = t('strategyForm.validation.balanceSlaveNumber')
      }
      if (!formData.quoteBalanceSlave) {
        errors.quoteBalanceSlave = t('strategyForm.validation.balanceSlaveRequired')
      }
      if (formData.quoteBalanceSlave && quoteSlaveAvailable !== undefined && parseFloat(formData.quoteBalanceSlave) > parseFloat(quoteSlaveAvailable)) {
        errors.quoteBalanceSlave = t('strategyForm.validation.balanceSlaveGreater', {value: quoteSlaveAvailable})
      }
      if (formData.quoteBalanceSlave && parseFloat(formData.quoteBalanceSlave) < 0) {
        errors.quoteBalanceSlave = t('strategyForm.validation.balanceSlavePositive')
      }
    }

    formData.type?.config?.forEach(field => {
      const fieldName = field.name
      const fieldValue = formData[fieldName]

      // Если AutoRebalance равно false и имя поля одно из указанных, пропустить валидацию
      if (
        formData['AutoRebalance'] === false &&
        (field.name === 'StartRebalanceProc' ||
          field.name === 'StartSkipDealsProc' ||
          field.name === 'StopStrategyProc')
      ) {
        return;
      }

      if (_.isNil(fieldValue)) {
        if (field.type === 'bool' && _.isUndefined(fieldValue)) {
          return
        }
        errors[fieldName] = t('strategyForm.validation.fieldRequired', {field: field.label})
      } else if (field.type === 'integer' && isNaN(parseInt(fieldValue))) {
        errors[fieldName] = t('strategyForm.validation.fieldInteger', {field: field.label})
      } else if (field.type === 'float' && isNaN(parseFloat(fieldValue))) {
        errors[fieldName] = t('strategyForm.validation.fieldFloat', {field: field.label})
      } else if (field.type === 'string' && fieldValue.trim() === '') {
        errors[fieldName] = t('strategyForm.validation.fieldString', {field: field.label})
      }

      if (fieldValue < 0) {
        errors[fieldName] = t('strategyForm.validation.fieldPositive', {field: field.label})
      }
      if (field.label.includes('%')) {
        if (fieldValue > 100) {
          errors[fieldName] = t('strategyForm.validation.fieldMaxPercent', {field: field.label})
        }
      }
    })

    return errors
  }

  const POLL_INTERVAL_MS = 2000
  // Запас над серверным таймаутом reload (BotReloadClient = 5 мин): даём BFF самому
  // зафиксировать терминальный статус ('failed' с реальным сообщением), прежде чем
  // показывать собственный «мягкий» таймаут.
  const POLL_MAX_MS = 7 * 60 * 1000
  // Допуск на рассинхрон часов клиента и сервера при проверке свежести метки updated.
  const FRESH_SKEW_MS = 60 * 1000

  const stopPolling = () => {
    if (pollRef.current) {
      clearInterval(pollRef.current)
      pollRef.current = null
    }
  }

  // reload завершён успешно: показываем «Сохранено» и возвращаемся к списку стратегий.
  const finishApplySuccess = () => {
    stopPolling()
    applyingRef.current = false
    if (!isMountedRef.current) return
    setApplyState({phase: 'idle', message: ''})
    dispatch(setSuccess(t('strategyForm.messages.strategyUpdated', {name: formData.name})))
    navigate('/admin/strategy')
  }

  // reload завершён с ошибкой: показываем сообщение сервера (если есть) и кнопку «Повторить».
  // message — «сырой» текст ошибки бэкенда, поэтому подчищаем переводы строк/пробелы.
  const finishApplyFailure = message => {
    stopPolling()
    applyingRef.current = false
    if (!isMountedRef.current) return
    setApplyState({
      phase: 'failed',
      message: typeof message === 'string' ? message.trim() : '',
    })
  }

  // Поллинг превысил дедлайн, а терминального статуса так и нет: применение, возможно,
  // ещё идёт на сервере. Показываем «мягкое» сообщение вместо жёсткой ошибки.
  const finishApplyTimeout = () => {
    stopPolling()
    applyingRef.current = false
    if (!isMountedRef.current) return
    setApplyState({phase: 'failed', message: '', timedOut: true})
  }

  // Терминальный статус ('done'/'failed') относится к НАШЕМУ сохранению, только если:
  //  - в этом цикле поллинга мы уже видели 'applying', ИЛИ
  //  - метка updated свежее момента старта сохранения (с допуском на рассинхрон часов).
  // Иначе это устаревшая запись или дефолтный 'done' из пустой in-memory карты BFF
  // (например, после рестарта процесса) — наш POST не запускал reload.
  const isOurTerminal = st => {
    if (seenApplyingRef.current) return true
    if (!st || !st.updated) return false
    const ts = Date.parse(st.updated)
    return !isNaN(ts) && ts >= submitStartedRef.current - FRESH_SKEW_MS
  }

  const handlePollResult = st => {
    if (!st || !st.status) return // временная ошибка сети — продолжаем поллить
    if (st.status === 'applying') {
      seenApplyingRef.current = true
      return // ещё применяется — ждём
    }
    // 'done' / 'failed' / неизвестный — терминальный статус
    if (!isOurTerminal(st)) {
      // Запись не относится к нашему сохранению => POST так и не запустил reload.
      finishApplyFailure('')
      return
    }
    if (st.status === 'done') {
      finishApplySuccess()
    } else {
      // 'failed' — неверные параметры / ошибка reload
      finishApplyFailure(st.message)
    }
  }

  const pollReloadStatus = sid => {
    stopPolling()
    seenApplyingRef.current = false
    pollDeadlineRef.current = Date.now() + POLL_MAX_MS
    pollRef.current = setInterval(async () => {
      if (Date.now() > pollDeadlineRef.current) {
        // Финальное чтение статуса перед объявлением таймаута: вдруг reload только что завершился.
        const st = await api.getStrategyReloadStatus(sid)
        if (!isMountedRef.current) return
        if (st && (st.status === 'done' || st.status === 'failed') && isOurTerminal(st)) {
          handlePollResult(st)
        } else {
          finishApplyTimeout()
        }
        return
      }
      const st = await api.getStrategyReloadStatus(sid)
      if (!isMountedRef.current) return
      handlePollResult(st)
    }, POLL_INTERVAL_MS)
  }

  // Отправка обновления: POST -> «Применяется…» -> поллинг исхода.
  // На любой не-ok ответ POST (сеть / 409 «уже применяется» / потерянный 200) НЕ объявляем
  // ошибку сразу: BFF выставляет статус reload в 'applying' синхронно ДО ответа 200, поэтому
  // реальный исход всегда приходит из reload_status (а проверка свежести отсекает ложный 'done').
  const submitUpdate = async requestData => {
    submitStartedRef.current = Date.now()
    applyingRef.current = true
    setApplyState({phase: 'applying', message: ''})
    const sid = requestData.data.strategy_id
    await api.updateStrategy(requestData)
    if (!isMountedRef.current) return
    pollReloadStatus(sid)
  }

  // Сборка payload из ТЕКУЩЕГО состояния формы (общая часть для создания и обновления).
  const buildRequestData = () => {
    const requestData = {
      strategy_type: formData.type.value,
      data: {
        uid: uid,
        cid: cid,
        enable_all: formData.enable_all,
        strategy_type: formData.type.value,
        strategy_name: formData.name,
        exchange: formData.exchange.label,
        keys_sets_id_1: formData.keys[0]?.value,
        pair: {
          base: formData.tradingPair?.label?.split('-')?.[0],
          quote: formData.tradingPair?.label?.split('-')?.[1],
        },
        balances: {
          base: parseFloat(formData.baseBalance),
          quote: parseFloat(formData.quoteBalance),
        },
      },
    }

    if (formData.type.value === 1) {
      requestData.data.balances_slave = {
        base: parseFloat(formData.baseBalanceSlave),
        quote: parseFloat(formData.quoteBalanceSlave),
      }
    }

    if (formData.keys[1]?.value) {
      requestData.data.keys_sets_id_2 = formData.keys[1]?.value
      requestData.data.balances_slave = {
        base: parseFloat(formData.baseBalanceSlave),
        quote: parseFloat(formData.quoteBalanceSlave),
      }
    }

    const config = {}
    formData.type?.config?.map(field => {
      const fieldName = field.name
      let fieldValue
      if (field.type === 'integer') {
        fieldValue = parseInt(formData[fieldName])
      } else if (field.type === 'float') {
        fieldValue = parseFloat(formData[fieldName])
      } else if (field.type === 'bool') {
        fieldValue = _.isBoolean(formData[fieldName]) ? formData[fieldName] : true
      } else if (field.type === 'string') {
        fieldValue = formData[fieldName]
      }
      config[fieldName] = fieldValue
    })

    requestData.data.config = config

    if (requestData.data.config.AutoRebalance === false) {
      requestData.data.config.StartRebalanceProc = 0
      requestData.data.config.StartSkipDealsProc = 0
      requestData.data.config.StopStrategyProc = 0
    }

    return requestData
  }

  // Собирает payload обновления из ТЕКУЩЕГО состояния формы, валидирует и отправляет.
  // Вызывается и из handleSubmit (кнопка «Сохранить»/Enter), и из кнопки «Повторить» —
  // поэтому правки пользователя после ошибки всегда попадают в повторный запрос.
  const submitCurrentUpdate = () => {
    if (applyingRef.current) return // уже идёт применение

    const errors = validateForm()
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors)
      return
    }
    if (!_.size(update_type)) {
      dispatch(setError(t('strategyForm.messages.nothingToUpdate')))
      return
    }

    const requestData = buildRequestData()
    requestData.data.strategy_id = strategyId
    requestData.data.active = formData.active
    requestData.data.update_type =
      update_type.balance && !update_type.config
        ? 'BALANCE'
        : !update_type.balance && update_type.config
          ? 'CONFIG'
          : 'FULL'

    submitUpdate(requestData)
  }

  const handleRetry = () => {
    submitCurrentUpdate()
  }

  const handleSubmit = e => {
    e.preventDefault()

    // Защита от повторной отправки (в т.ч. Enter в поле) во время применения.
    if (applyingRef.current) return

    // Редактирование существующей стратегии — асинхронный путь (POST -> «Применяется…» -> поллинг).
    if (strategyId) {
      submitCurrentUpdate()
      return
    }

    // Создание новой стратегии — синхронный POST.
    const errors = validateForm()
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors)
      return
    }

    const requestData = buildRequestData()
    api
      .createStrategy(requestData)
      .then(res => {
        if (res.id) {
          dispatch(setSuccess(t('strategyForm.messages.strategyCreated', {name: formData.name})))
          navigate('/admin/strategy')
        }
      })
      .catch(e => console.error('createStrategy error ', e))
  }

  const exchangeOptions =
    exchangesData?.exchanges?.map(exchange => ({
      value: exchange.eid,
      label: exchange.name,
    })) || []

  const strategiesTypeOptions =
    strategiesData?.types?.map(strategy => ({
      value: strategy.strategy_type_id,
      label: strategy.strategy_type_name,
      keys: strategy.key_numbers,
      config: strategy.config,
    })) || []

  const keyOptions =
    keysSetsData?.keysSets
      .filter(
        keySet =>
          !formData.keys || !formData.keys.some(selectedKey => selectedKey?.value === keySet.id),
      )
      .filter(keySet => !selectedExchange || keySet.exchange === selectedExchange.label)
      .map(keySet => ({
        value: keySet.id,
        label: keySet.name,
        exchange: keySet.exchange,
      })) || []


  return (
    <div className='content'>
      <Row>
        <Col className='' xl={6}>
          <Card>
            <CardBody>
              <h2>{strategyId ? t('strategyForm.titleEdit') : t('strategyForm.titleAdd')}</h2>
              <form onSubmit={handleSubmit} noValidate>
                <FormGroup>
                  <Label for={'enable_all'}>
                    {t('strategyForm.enableAllUsers')}
                  </Label>
                  <div className='d-flex align-items-center mt-2'>
                    <Toggle
                      id={'enable_all'}
                      name={'enable_all'}
                      checked={formData.enable_all}
                      defaultChecked={true}
                      onChange={e => {
                        handleChange('enable_all', e.target.checked)
                        setUpdate_type({
                          ...update_type,
                          config: true,
                        })
                      }}
                    />
                  </div>
                </FormGroup>
                <FormGroup>
                  <Label for='name'>
                    {t('strategyForm.strategyName')}<span className='text-danger'>*</span>
                  </Label>
                  <Input
                    type='text'
                    name='name'
                    id='name'
                    placeholder={t('strategyForm.enterStrategyName')}
                    value={formData.name}
                    onChange={e => handleChange('name', e.target.value)}
                    required
                    className='mb-0'
                    disabled={!!strategyId}
                  />
                  {formErrors.name && <p className='text-danger'>{formErrors.name}</p>}
                </FormGroup>

                <FormGroup>
                  <Label for='type'>
                    {t('strategyForm.strategyType')}<span className='text-danger'>*</span>
                  </Label>
                  <Select
                    options={_.reverse(strategiesTypeOptions)}
                    value={formData.type}
                    onChange={handleStrategyTypeChange}
                    placeholder={t('strategyForm.selectStrategyType')}
                    styles={localStorage.getItem('darkMode') === 'true' ? reactSelectStyles(!!strategyId) : reactSelectLightStyles(!!strategyId) }
                    required
                    className='mb-0'
                    isDisabled={!!strategyId}
                    noOptionsMessage={() => t('select.noOptionsMessage')}
                  />
                  {formErrors.type && <p className='text-danger'>{formErrors.type}</p>}
                </FormGroup>

                <FormGroup>
                  <Label for='exchange'>
                    {t('strategyForm.exchange')}<span className='text-danger'>*</span>
                  </Label>
                  <Select
                    options={exchangeOptions}
                    value={formData.exchange}
                    onChange={handleExchangeChange}
                    placeholder={t('strategyForm.selectExchange')}
                    required={true}
                    styles={localStorage.getItem('darkMode') === 'true' ? reactSelectStyles(!!strategyId) : reactSelectLightStyles(!!strategyId) }
                    className='mb-0'
                    isDisabled={!!strategyId}
                    noOptionsMessage={() => t('select.noOptionsMessage')}
                  />
                  {formErrors.exchange && <p className='text-danger'>{formErrors.exchange}</p>}
                </FormGroup>

                {selectedExchange && (
                  <FormGroup>
                    <Label for='keys'>
                      {formData.type?.keys === 2 ? t('strategyForm.keys') : t('strategyForm.key')}
                      <span className='text-danger'>*</span>
                    </Label>
                    <Select
                      options={keyOptions}
                      value={formData.keys ? formData.keys[0] : null}
                      onChange={selectedOption => handleKeysChange(selectedOption, 0)}
                      placeholder={t('strategyForm.selectKey')}
                      styles={localStorage.getItem('darkMode') === 'true' ? reactSelectStyles(!!strategyId) : reactSelectLightStyles(!!strategyId) }
                      required
                      className='mb-0'
                      isDisabled={!!strategyId}
                      noOptionsMessage={() => t('select.noOptionsMessage')}
                    />
                    {formData.type?.keys === 2 && (
                      <Select
                        options={keyOptions}
                        value={formData.keys ? formData.keys[1] : null}
                        onChange={selectedOption => handleKeysChange(selectedOption, 1)}
                        placeholder={t('strategyForm.selectKey')}
                        styles={localStorage.getItem('darkMode') === 'true' ? reactSelectStyles(!!strategyId) : reactSelectLightStyles(!!strategyId) }
                        className='mt-3 mb-0'
                        required
                        noOptionsMessage={() => t('select.noOptionsMessage')}
                        // isDisabled={!!strategyId}
                      />
                    )}
                    {formErrors.keys && <p className='text-danger'>{formErrors.keys}</p>}
                  </FormGroup>
                )}

                {showTradingPair && (
                  <FormGroup>
                    <Label for='tradingPair'>
                      {t('strategyForm.tradingPair')}<span className='text-danger'>*</span>
                    </Label>
                    <Select
                      options={tradingPairs.map(pair => ({
                        value: pair,
                        label: pair,
                      }))}
                      value={formData.tradingPair}
                      onChange={handleTradingPairChange}
                      placeholder={t('strategyForm.selectTradingPair')}
                      styles={localStorage.getItem('darkMode') === 'true' ? reactSelectStyles(!!strategyId) : reactSelectLightStyles(!!strategyId) }
                      required
                      className='mb-0'
                      isDisabled={!!strategyId}
                      noOptionsMessage={() => t('select.noOptionsMessage')}
                    />
                    {formErrors.tradingPair && (
                      <p className='text-danger'>{formErrors.tradingPair}</p>
                    )}
                  </FormGroup>
                )}

                {formData.tradingPair && (
                  <>
                    <FormGroup>
                      <Label for='baseBalance'>
                        {formData?.tradingPair?.value?.split('-')?.[0]} {t('strategyForm.balance')}
                        ({t('strategyForm.available')}: {balance?.[formData?.tradingPair?.value?.split('-')?.[0]] || 0})
                      </Label>
                      <Input
                        type='number'
                        step='0.01'
                        name='baseBalance'
                        id='baseBalance'
                        placeholder={t('strategyForm.enterBalance', {currency: formData?.tradingPair?.value?.split('-')?.[0]})}
                        value={formData.baseBalance}
                        onChange={e => {
                          handleChange('baseBalance', e.target.value)
                          setUpdate_type({
                            ...update_type,
                            balance: true,
                          })
                        }}
                        required
                        className='mb-0'
                        disabled={balanceLoading}
                      />
                      {formErrors.baseBalance && (
                        <p className='text-danger'>{formErrors.baseBalance}</p>
                      )}
                    </FormGroup>

                    <FormGroup>
                      <Label for='quoteBalance'>
                        {formData?.tradingPair?.value?.split('-')?.[1]} {t('strategyForm.balance')}
                        ({t('strategyForm.available')}: {balance?.[formData?.tradingPair?.value?.split('-')?.[1]] || 0})
                      </Label>
                      <Input
                        type='number'
                        step='0.01'
                        name='quoteBalance'
                        id='quoteBalance'
                        placeholder={t('strategyForm.enterBalance', {currency: formData?.tradingPair?.value?.split('-')?.[1]})}
                        value={formData.quoteBalance}
                        onChange={e => {
                          handleChange('quoteBalance', e.target.value)
                          setUpdate_type({
                            ...update_type,
                            balance: true,
                          })
                        }}
                        required
                        className='mb-0'
                        disabled={balanceLoading}
                      />
                      {formErrors.quoteBalance && (
                        <p className='text-danger'>{formErrors.quoteBalance}</p>
                      )}
                    </FormGroup>
                    {formData.type.value === 1 &&
                      <>
                      <FormGroup>
                        <Label for='baseBalanceSlave'>
                          {formData?.tradingPair?.value?.split('-')?.[0]} {t('strategyForm.balanceSlave')}
                          ({t('strategyForm.available')}: {balanceSlave?.[formData?.tradingPair?.value?.split('-')?.[0]] || 0})
                        </Label>
                        <Input
                          type='number'
                          step='0.01'
                          name='baseBalanceSlave'
                          id='baseBalanceSlave'
                          placeholder={t('strategyForm.enterBalanceSlave', {currency: formData?.tradingPair?.value?.split('-')?.[0]})}
                          value={formData.baseBalanceSlave}
                          onChange={e => {
                            handleChange('baseBalanceSlave', e.target.value)
                            setUpdate_type({
                              ...update_type,
                              balance: true,
                            })
                          }}
                          required
                          className='mb-0'
                          disabled={balanceLoading}
                        />
                        {formErrors.baseBalanceSlave && (
                          <p className='text-danger'>{formErrors.baseBalanceSlave}</p>
                        )}
                      </FormGroup>

                        <FormGroup>
                          <Label for='quoteBalanceSlave'>
                            {formData?.tradingPair?.value?.split('-')?.[1]} {t('strategyForm.balanceSlave')}
                            ({t('strategyForm.available')}: {balanceSlave?.[formData?.tradingPair?.value?.split('-')?.[1]] || 0})
                          </Label>
                          <Input
                            type='number'
                            step='0.01'
                            name='quoteBalanceSlave'
                            id='quoteBalanceSlave'
                            placeholder={t('strategyForm.enterBalanceSlave', {currency: formData?.tradingPair?.value?.split('-')?.[1]})}
                            value={formData.quoteBalanceSlave}
                            onChange={e => {
                              handleChange('quoteBalanceSlave', e.target.value)
                              setUpdate_type({
                                ...update_type,
                                balance: true,
                              })
                            }}
                            required
                            className='mb-0'
                            disabled={balanceLoading}
                          />
                          {formErrors.quoteBalanceSlave && (
                            <p className='text-danger'>{formErrors.quoteBalanceSlave}</p>
                          )}
                        </FormGroup>

                      </>
                    }
                  </>
                )}

                {formData.type?.config?.map(field => {
                  const fieldLabel = field?.label ?? field?.name
                  const fieldPlaceholder = typeof fieldLabel === 'string' ? fieldLabel.toLowerCase() : fieldLabel
                  return (
                  <div key={field.name}>
                    <FormGroup>
                      <Label for={field.name}>
                        {field.label}
                        <span className='text-danger'>*</span>
                      </Label>
                      {field.type === 'integer' ? (
                        <>
                          <Input
                            type='number'
                            id={field.name}
                            name={field.name}
                            value={_.isNil(formData[field.name]) ? '' : formData[field.name]}
                            onChange={e => {
                              handleChange(field.name, e.target.value)
                              setUpdate_type({
                                ...update_type,
                                config: true,
                              })
                            }}
                            placeholder={t('strategyForm.enterField', {field: fieldPlaceholder})}
                            required={field.required}
                            className='mb-0'
                            disabled={
                              formData['AutoRebalance'] === false &&
                              (field.name === 'StartRebalanceProc' ||
                                field.name === 'StartSkipDealsProc' ||
                                field.name === 'StopStrategyProc')
                            }
                          />
                        </>
                      ) : field.type === 'float' ? (
                        <Input
                          type='number'
                          step='0.01'
                          id={field.name}
                          name={field.name}
                          value={_.isNil(formData[field.name]) ? '' : formData[field.name]}
                          onChange={e => {
                            handleChange(field.name, e.target.value)
                            setUpdate_type({
                              ...update_type,
                              config: true,
                            })
                          }}
                          placeholder={t('strategyForm.enterField', {field: fieldPlaceholder})}
                          required={field.required}
                          className='mb-0'
                        />
                      ) : field.type === 'bool' ? (
                        <div className='d-flex align-items-center mt-2'>
                          <Toggle
                            id={field.name}
                            name={field.name}
                            checked={_.isBoolean(formData[field.name]) ? formData[field.name] : true}
                            onChange={e => {
                              handleChange(field.name, e.target.checked)
                              setUpdate_type({
                                ...update_type,
                                config: true,
                              })
                            }}
                          />
                        </div>
                      ) : (
                        <Input
                          type='text'
                          id={field.name}
                          name={field.name}
                          value={formData[field.name] || ''}
                          onChange={e => {
                            handleChange(field.name, e.target.value);
                            setUpdate_type({
                              ...update_type,
                              config: true,
                            })
                          }}
                          placeholder={t('strategyForm.enterField', {field: fieldPlaceholder})}
                          required={field.required}
                          className='mb-0'
                        />
                      )}
                      {formErrors[field.name] && (
                        <p className='text-danger'>{formErrors[field.name]}</p>
                      )}
                    </FormGroup>
                  </div>
                )})}

                <div className='w-100 d-flex flex-column align-items-end'>
                  {applyState.phase === 'failed' && (
                    <div className='w-100 mb-2'>
                      <p className={applyState.timedOut ? 'text-warning mb-1' : 'text-danger mb-1'}>
                        {t(applyState.timedOut
                          ? 'strategyForm.messages.applyTimeout'
                          : 'strategyForm.messages.reloadFailed')}
                      </p>
                      {applyState.message && (
                        <p
                          className='text-muted mb-2'
                          style={{
                            fontSize: '0.85em',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                          }}>
                          {applyState.message}
                        </p>
                      )}
                      <Button color='warning' type='button' onClick={handleRetry}>
                        {t('strategyForm.messages.retry')}
                      </Button>
                    </div>
                  )}
                  {applyState.phase === 'applying' && (
                    <div className='d-flex align-items-center mb-2'>
                      <Spinner size='sm' color='primary' className='mr-2' />
                      <span>{t('strategyForm.messages.applying')}</span>
                    </div>
                  )}
                  <Button
                    color='primary'
                    type='submit'
                    disabled={applyState.phase === 'applying'}>
                    {strategyId ? t('strategyForm.save') : t('strategyForm.create')}
                  </Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default StrategyForm
